/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const saveCustomerPhoneSettingsBodyVersionExclusiveMin = 0;
export const saveCustomerPhoneSettingsBodyVersionMax = 9007199254740991;

export const saveCustomerPhoneSettingsBodyClientCodeMin = 4;
export const saveCustomerPhoneSettingsBodyClientCodeMax = 4;

export const saveCustomerPhoneSettingsBodyClientCodeRegExp = new RegExp('^[0-9]{4}$');
export const saveCustomerPhoneSettingsBodyRecognizedCallerGreetingOneTwoTextMax = 400;

export const saveCustomerPhoneSettingsBodyRecognizedCallerGreetingOneThreeAssetIdRegExp =
  new RegExp(
    '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
  );

export const SaveCustomerPhoneSettingsBody = zod.object({
  version: zod
    .int()
    .gt(saveCustomerPhoneSettingsBodyVersionExclusiveMin)
    .max(saveCustomerPhoneSettingsBodyVersionMax),
  clientCode: zod
    .string()
    .min(saveCustomerPhoneSettingsBodyClientCodeMin)
    .max(saveCustomerPhoneSettingsBodyClientCodeMax)
    .regex(saveCustomerPhoneSettingsBodyClientCodeRegExp),
  recognizedCallerGreeting: zod.union([
    zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod
          .string()
          .min(1)
          .max(saveCustomerPhoneSettingsBodyRecognizedCallerGreetingOneTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(saveCustomerPhoneSettingsBodyRecognizedCallerGreetingOneThreeAssetIdRegExp),
      }),
    ]),
    zod.null(),
  ]),
});

export type SaveCustomerPhoneSettingsBody = zod.input<typeof SaveCustomerPhoneSettingsBody>;
export type SaveCustomerPhoneSettingsBodyOutput = zod.output<typeof SaveCustomerPhoneSettingsBody>;
